import { motion } from "framer-motion";
import { Loader2 } from "lucide-react";

export const LoadingState = () => {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="text-center"
      >
        <Loader2 className="h-12 w-12 text-primary animate-spin mx-auto mb-4" />
        <h2 className="text-xl font-semibold text-foreground mb-2">
          Loading Dashboard
        </h2>
        <p className="text-sm text-muted-foreground">
          Fetching live energy data...
        </p>
      </motion.div>
    </div>
  );
};

export const ShimmerCard = () => {
  return (
    <div className="bg-card rounded-lg p-6 animate-pulse">
      <div className="h-4 bg-secondary rounded w-1/3 mb-4"></div>
      <div className="h-8 bg-secondary rounded w-1/2 mb-2"></div>
      <div className="h-3 bg-secondary rounded w-2/3"></div>
    </div>
  );
};
